/**
 * Composant pour afficher l'état de la connexion réseau
 * @returns 
 */
import { useState, useEffect } from "react";
import { Wifi, WifiOff } from "lucide-react";

export const ConnectionIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-medium ${
        isOnline
          ? "bg-green-100 text-green-700 border border-green-300"
          : "bg-red-100 text-red-700 border border-red-300"
      }`}
    >
      {isOnline ? (
        <>
          <Wifi className="h-4 w-4" />
        </>
      ) : (
        <>
          <WifiOff className="h-4 w-4" />
        </>
      )}
    </div>
  );
};
